var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-free"},[(_vm.showFree)?[(_vm.showFree)?_c('TipsInfo',{on:{"show":_vm.show,"changeView":_vm.changeView}}):_vm._e()]:_vm._e(),(_vm.showDesglose)?[_c('TipsDesglose',{attrs:{"isTips":true},on:{"show":_vm.show,"changeView":_vm.changeView}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }